import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import localizedFormat from "dayjs/plugin/localizedFormat";
import relativeTime from "dayjs/plugin/relativeTime";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

// The one place dayjs gets its plugins. Apps import dayjs from here (web
// re-exports it from @/core/utils/date), so every caller has the same set.
dayjs.extend(localizedFormat);
dayjs.extend(timezone);
dayjs.extend(utc);
dayjs.extend(advancedFormat);
dayjs.extend(customParseFormat);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(relativeTime);

export { dayjs };

export const FORMAT_TYPEABLE_DATE = "MM / DD / YYYY"; // For typeable date picker
export const FORMAT_TYPEABLE_DATE_PLACEHOLDER = "mm / dd / yyyy";

// Half-hour time options from `startTime` ("h:mm a") to the end of the day.
export const generateTimeOptions = (startTime?: string) => {
  const options: { value: string; label: string }[] = [];

  let start = 0;
  if (startTime) {
    const parsedTime = dayjs(startTime, "h:mm a", true);
    if (parsedTime.isValid()) {
      start = parsedTime.hour() * 60 + parsedTime.minute();
    }
  }

  for (let minutes = start; minutes < 24 * 60; minutes += 30) {
    const hour = Math.floor(minutes / 60);
    const minute = minutes % 60;
    const period = hour >= 12 ? "pm" : "am";
    const displayHour = hour % 12 || 12;
    const displayMinute = minute.toString().padStart(2, "0");
    const label = `${displayHour}:${displayMinute} ${period}`;
    const value = dayjs().hour(hour).minute(minute).format("h:mm a");
    options.push({ value, label });
  }
  return options;
};
